import { zipCodeConstraints } from "src/constraints";

export const contactFields = ({
  t,
  includeAccountNumber = true,
  includePhoneType = false,
  includeEmail = true,
  phoneRequired = false,
  emailRequired = false,
}) => [
  [
    {
      key: "firstName",
      label: t("forms.firstName"),
      required: true,
    },
    {
      key: "lastName",
      label: t("forms.lastName"),
      required: true,
    },
  ],
  includePhoneType
    ? [
        {
          key: "phoneNumber",
          label: t("forms.phoneNumber"),
          required: phoneRequired,
        },
        {
          key: "phoneType",
          label: t("forms.phoneType", {
            defaultValue: "Phone Number Type",
          }),
          type: "dropdown",
          inputProps: {
            suppressLabel: true,
            options: [
              {
                value: "home",
                label: t("forms.phoneTypeLabel.home", {
                  defaultValue: "Home",
                }),
              },
              {
                value: "work",
                label: t("forms.phoneTypeLabel.work", {
                  defaultValue: "Work",
                }),
              },
              {
                value: "cell",
                label: t("forms.phoneTypeLabel.cell", {
                  defaultValue: "Cell",
                }),
              },
            ],
          },
          required: phoneRequired,
        },
      ]
    : {
        key: "phoneNumber",
        label: t("forms.phoneNumber"),
        required: phoneRequired,
      },
  includeEmail && {
    key: "email",
    label: t("forms.emailAddress"),
    inputProps: {
      type: "email",
    },
    required: emailRequired,
    constraints: {
      equality: {
        attribute: "phoneNumber",
        message: `^${t("forms.phoneOrEmailError")}`,
        comparator: (v1, v2) => v1 || v2,
      },
      email: emailRequired,
    },
  },
  values =>
    values.email &&
    values.phoneNumber && {
      key: "preferredContactMethod",
      label: t("forms.preferredContactMethod"),
      type: "optionButtons",
      inputProps: {
        options: [
          {
            value: "phone",
            label: t("forms.phoneOption"),
          },
          {
            value: "email",
            label: t("forms.emailOption"),
          },
        ],
      },
    },
  includeAccountNumber && {
    key: "accountNumber",
    label: t("forms.accountNumber"),
    inputProps: {
      type: "password",
    },
  },
  values =>
    values.phoneNumber && {
      key: "bestTime",
      label: t("forms.bestTimeLabel"),
      helpText: t("forms.bestTimeHelp"),
    },
];

export const addressFields = ({ t }) => [
  {
    key: "street1",
    required: true,
    label: t("forms.address.street1", {
      defaultValue: "Street 1",
    }),
  },
  {
    key: "street2",
    label: t("forms.address.street2", {
      defaultValue: "Street 2",
    }),
  },
  [
    {
      key: "city",
      required: true,
      label: t("forms.address.city", {
        defaultValue: "City",
      }),
      displayProps: {
        flex: 3,
      },
    },
    {
      key: "state",
      required: true,
      label: t("forms.address.state", {
        defaultValue: "State",
      }),
      displayProps: {
        flex: 1,
      },
      constraints: {
        format: {
          pattern: /^[A-Z]{2}$/,
          message: `^${t("forms.address.stateErrorMessage", {
            defaultValue: "Please use the two-letter capitalized state code.",
          })}`,
        },
      },
    },
    {
      key: "zipCode",
      required: true,
      label: t("forms.address.zipCode", {
        defaultValue: "Zip Code",
      }),
      displayProps: {
        flex: 1,
      },
      inputProps: {
        numeric: true,
      },
      constraints: zipCodeConstraints,
    },
  ],
];



// WEBPACK FOOTER //
// ./src/components/Content/forms/fields.js